const validate = values => {
	const errors = {}
	if (!values.email) {
		errors.email = 'Este campo es obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsAuthForm.js
 **/